
import { DEFAULT_LOCALE, DEFAULT_COUNTRY, DEFAULT_GROUP_MEMBER, DEFAULT_GLOBAL_CHANNEL, DEFAULT_GBGF, DEFAULT_CLIENT_ID, DEFAULT_CORRELATION } from '@sgp/data/defaults';
import { getStoredAccessToken, getUserEmail, getUserCuid } from '@sgp/cognito';
export const getHeaders = () => {
  // Cognito-only identity headers. They must be omitted entirely (not sent empty)
  // when no Cognito session exists: the SSO (DSP) path authenticates with the
  // AMToken session cookie and `Token_Type: SESSION_TOKEN`, and the internal-proxy
  // gateway rejects the request with a 401 when an empty `Authorization: Bearer `
  // is present. The 401 in turn triggers the global re-login redirect to /logout.
  const accessToken = getStoredAccessToken();
  const userEmail = getUserEmail();
  const userCuid = getUserCuid();

  let defaultHeaders =  {
    'Content-Type': 'application/json',
    'X-HSBC-Chnl-CountryCode': DEFAULT_COUNTRY,
    'X-HSBC-Chnl-Group-Member': DEFAULT_GROUP_MEMBER,
    'X-HSBC-Global-Channel-Id': DEFAULT_GLOBAL_CHANNEL,
    'X-HSBC-Request-Correlation-Id': DEFAULT_CORRELATION,
    'Accept-Language': DEFAULT_LOCALE,
    'X-HSBC-Source-System-Id': 'DP',
    'X-HSBC-Channel-Id': 'WEB',
    'X-HSBC-Locale': 'en_GB',
    ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {}),
    ...(userEmail ? { 'X-HSBC-User-Email': userEmail } : {}),
    ...(userCuid ? { 'X-HSBC-User-Cuid': userCuid } : {})
  };
  
   if (APP_ENV === 'DIT'){ //local environment only for tes
    defaultHeaders = {...defaultHeaders , 'x-hsbc-e2e-trust-token': localStorage.getItem('advisor')}
   } 

  return defaultHeaders;
};

export default getHeaders;
